module.exports = __webpack_public_path__ + "static/media/btn_large.6fc52863.svg";